import { z } from 'zod';
import { IsoDateTimeSchema, SegmentSchema, UuidSchema } from './common.js';

export const TagSchema = z.object({
  tag_id: UuidSchema,
  name: z.string().min(1).max(64),
  color: z.string().nullable().optional(),
  scope_segment: SegmentSchema.nullable(),
  description: z.string().nullable().optional(),
  // V1.5: Verantwortliche:r des Themenbereichs → schaltet die Manager-Persona frei.
  manager_user_id: UuidSchema.nullable().optional(),
  created_at: IsoDateTimeSchema,
  created_by: UuidSchema.nullable().optional(),
});
export type Tag = z.infer<typeof TagSchema>;

export const CreateTagInputSchema = z.object({
  name: z.string().min(1).max(64),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .nullable()
    .optional(),
  scope_segment: SegmentSchema.nullable().optional(),
  description: z.string().max(500).nullable().optional(),
  manager_user_id: UuidSchema.nullable().optional(),
});
export type CreateTagInput = z.infer<typeof CreateTagInputSchema>;

export const UpdateTagInputSchema = CreateTagInputSchema.partial();
export type UpdateTagInput = z.infer<typeof UpdateTagInputSchema>;
